import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api-service';
import ShareService from '../services/share-service';

const GET_SHARE_QUEUE = `
query getShareQueue {
	session {
		id
		shareQueue {
			id
			mediaType
		}
	}
}
`;

function useShareQueue() {

	const queryClient = useQueryClient();

	const { isInitialLoading: isLoading, isError, data } = useQuery({
		queryKey: ['getShareQueue'],
		queryFn: () => api.graphql.request(GET_SHARE_QUEUE),
		staleTime: Infinity,
		cacheTime: Infinity
	});

	const session = data?.session;
	const sessionId = session?.id;
	const shareQueue = session?.shareQueue || [];

	const { mutateAsync: updateShareQueue } = useMutation(
		(queue) => ShareService.updateShareQueue(sessionId, queue),
		{
			onMutate: async(newShareQueue) => {
				await queryClient.cancelQueries(['getShareQueue']);
				const previousShareQueue = queryClient.getQueryData(['getShareQueue']);

				queryClient.setQueryData(['getShareQueue'], (oldData) => {
					return {
						...oldData,
						session: {
							...oldData?.session,
							shareQueue: newShareQueue
						}
					};
				});

				return { previousShareQueue };
			},
			onError: (err, newShareQueue, context) => {
				queryClient.setQueryData(['getShareQueue'], context.previousShareQueue);
			},
			onSettled: () => {
				queryClient.invalidateQueries(['getShareQueue']);
			}
		}
	);

	return [updateShareQueue, shareQueue, { isLoading, isError }];
}

export default useShareQueue;
